module.exports = __webpack_public_path__ + "img/globe-solid.477e9e32.svg";